import React, {createContext, useMemo} from "react";
import { useStorageReducer } from 'react-storage-hooks';

const reducer = (state, action) => {
    if (process.env.NODE_ENV === 'development') {
        console.log('app reducer:', action.type);
    }
    switch(action.type) {
        case 'login':
            return {...state, currentUser: action.user, jwt: action.jwt };

        case 'refreshToken':
            return {...state, jwt: action.jwt };

        case 'logout':
            clearSession();
            clearApp();
            clearShareLinkCode()
            return {...state, currentUser: null, jwt: null, switchedFromUser: null };

        case 'user_updated': {
            const user = {...action.user};
            if(state.currentUser?.switch_token && !Object.prototype.hasOwnProperty.call(user, 'switch_token')) {
                user.switch_token = state.currentUser.switch_token;
            }
            return {...state, currentUser: user };
        }

        case 'setLastOrganization':
            return {...state, currentUser: {...state.currentUser, last_organization: action.org } };

        case 'switchUser':
            clearSession();
            clearShareLinkCode()
            return {...state, currentUser: action.user, jwt: action.user.jwt, switchedFromUser: state.currentUser };

        case 'switchBack':
            clearSession();
            clearShareLinkCode()
            return {...state, currentUser: action.user, jwt: action.user.jwt, switchedFromUser: null };

        case 'setShareLink':
            return {...state, shareLink: action.shareLink };

        default:
            return state;
    }
};

const initialState = {
    currentUser: null,
    switchedFromUser: null,
    jwt: null,
    shareLink: null,
};

const AppContext = createContext(initialState);

function AppProvider(props) {
    const key = 'app-reducer'
    const [state, dispatch, writeError] = useStorageReducer(localStorage, key, reducer, initialState);

    window.clearApp = ()=> localStorage.removeItem(key);

    window.onstorage = () => {
        const appState = JSON.parse(window.localStorage.getItem(key));

        if(appState && (appState.currentUser?.id !== state.currentUser?.id)) location.reload()
    };

    const contextValue = useMemo(() => ({state, dispatch}), [state, dispatch])

    return <AppContext.Provider value={contextValue} {...props}/>;
}

export { AppContext, AppProvider, reducer, initialState };
